import React from 'react';
import { Typography } from '@mui/material';
import { InsertChartOutlined } from '@mui/icons-material';
import { LightChip } from '../../LightChip';
import { BaseActivityItem } from '../BaseActivityItem';
import { CalendarDateService } from '@uplift/services';


export type FormActivityItemProps = {
  title: string;
  completedAt?: string;
  expiredAt?: string;
  onClick?: () => void;
};


export const FormActivityItem: React.FC<FormActivityItemProps> = (props) => {
  if (props.expiredAt) {
    const expiredAt = CalendarDateService.date(props.expiredAt);

    return (
      <BaseActivityItem
        onClick={props.onClick}
        title={props.title}
        color="primary"
        icon={InsertChartOutlined}
        chip={<LightChip label={`Expired ${expiredAt.format('MMM D, YYYY')}`} size="small" />}
        rightContent={<Typography variant="body2" color="textPrimary">by UpLift</Typography>}
      />
    );
  }

  if (props.completedAt) {
    return (
      <BaseActivityItem
        onClick={props.onClick}
        title={props.title}
        color="primary"
        icon={InsertChartOutlined}
        rightContent={<Typography variant="body2" color="textPrimary">by UpLift</Typography>}
        children={props.children}
      />
    );
  }

  return (
    <BaseActivityItem
      onClick={props.onClick}
      title={props.title}
      color="primary"
      icon={InsertChartOutlined}
      chip={<LightChip label="Incomplete" size="small" color="warning" />}
      rightContent={<Typography variant="body2" color="textPrimary">by UpLift</Typography>}
      children={props.children}
    />
  );
};
